var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board"},_vm._l((_vm.currencies),function(value){return _c('div',{key:value.symbol,staticClass:"card-block"},[_c('CurrencyCard',{attrs:{"ticker":_vm.tickers[value.symbol] || {},"info":value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }